import {HeaderContainer, HeaderImage} from './styledComponents'

const Header = () => (
  <HeaderContainer>
    <HeaderImage
      src="https://assets.ccbp.in/frontend/react-js/projects-showcase/website-logo-img.png"
      alt="website logo"
    />
  </HeaderContainer>
)

export default Header
